import React, { Component } from "react";
import { Link } from "react-router-dom";
//

//
//
class Contact extends Component {
  //
  state = {
    links: [
      {
        id: "0",
        target: "",
        label: "FACEBOOK",
      },
      {
        id: "1",
        target: "",
        label: "ARTSTATION",
      },
      {
        id: "2",
        target: "",
        label: "SHOP",
      },
    ],
  };
  //
  //
  //
  render() {
    return (
      <React.Fragment>
        <section id="contact">
          <div className="contact___wrapper">
            {/* ------------o---------------- */}

            <div className="contactBoxOne">
              <ul>
                <li>
                  <Link to="/Portfolio" className="ul-li-navOpen">
                    Portfolio
                  </Link>
                </li>
                <li>
                  <Link to="Process" className="ul-li-navOpen">
                    Process
                  </Link>
                </li>
                <li>
                  <Link to="drawings" className="ul-li-navOpen">
                    Drawings
                  </Link>
                </li>
              </ul>

              <h4>CONTACT</h4>

              <p>
                Feel free to contact us by email at <span>&#x27F6;</span>
              </p>
              <h6 className="email_mobile">volkanuve@protonmail.com</h6>
            </div>
            {/* ------////------ */}
            <div className="contactBoxTwoWrapper">
              <div className="contactBoxTwo">
                {/* ----- */}
                <ul>
                  {this.state.links.map((link) => (
                    <li key={link.id}>
                      <a
                        className="ul-li-navOpen"
                        href={link.target}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>

                <p className="email_contact">volkanuve@protonmail.com</p>
              </div>
              {/* ------////------ */}
              <div className="contactBoxThree">
                <ul>
                  <li>
                    <Link to="faq" className="ul-li-navOpen">
                      FAQ/LEGAL
                    </Link>
                  </li>
                </ul>
                <h6>
                  <span className="copyright-footer">&#xa9;</span> 2021 VOLKANUVE
                </h6>
              </div>
            </div>

            {/* ------------o---------------- */}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Contact;
